import React, { useEffect, useState } from "react";
import { InputMask } from "primereact/inputmask";
import { Button } from "primereact/button";
import { databaseOrders, ref, push } from "../firebase";
import logo from "../images/logo.svg";
import { InputText } from "primereact/inputtext";
import { capitalize, formatShortDate } from "../helpers/helpers";

function ContactMeBlock() {
    const [phoneNumber, setPhoneNumber] = useState("");
    const [name, setName] = useState("");
    const [isValid, setIsValid] = useState(true);
    const [order, setOrder] = useState("");

    const handleClick = () => {
        if (phoneNumber && phoneNumber.length === 18) {
            const orderObject = {
                phoneNumber,
                name,
                product: {
                    article: "-",
                    name: "Прохання консультації",
                },
                date: formatShortDate(new Date()),
                isHandled: false,
            };
            addUserDataWithPush(orderObject);
        } else {
            setIsValid(false);
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    };

    async function addUserDataWithPush(userData) {
        try {
            const ordersRef = ref(databaseOrders, "/orders");
            const newUserDataRef = await push(ordersRef, userData);
            setOrder(newUserDataRef.key);
        } catch (error) {
            console.error("Error pushing data:", error);
        }
    }

    useEffect(() => {
        window.scrollTop =
            window.scrollY ||
            document.documentElement.scrollTop ||
            document.body.scrollTop;
        window.scrollLeft =
            window.scrollX ||
            document.documentElement.scrollLeft ||
            document.body.scrollLeft;

        document.body.style.overflow = "hidden";
        document.body.style.position = "fixed";
        document.body.style.top = `-${window.scrollTop}px`;
        document.body.style.left = `-${window.scrollLeft}px`;
        document.body.style.width = "100%";

        return () => {
            const savedScrollTop = window.scrollTop;
            const savedScrollLeft = window.scrollLeft;

            document.body.style.overflow = "";
            document.body.style.position = "";
            document.body.style.top = "";
            document.body.style.left = "";
            document.body.style.width = "";

            window.scrollTo(savedScrollLeft, savedScrollTop);
        };
    }, []);

    return (
        <div className="flex flex-col justify-center items-center pt-4">
            {order ? (
                <div className="text-xl text-center flex flex-col justify-center items-center">
                    <span>Дякуємо за вашу зацікавленість!</span>
                    <img
                        className="h-[100px] my-4"
                        src={logo}
                        alt="ЦАЦКИ ХЮФ"
                    />
                    <span>Невдовзі ми зв'яжемося з вами.</span>
                </div>
            ) : (
                <>
                    <div className="flex flex-col gap-2 md:gap-4 items-center">
                        <div className="flex gap-2 lg:gap-4 flex-col lg:flex-row">
                            <div>
                                <label
                                    htmlFor="phone"
                                    className="font-bold block mb-2"
                                >
                                    Номер телефону*
                                </label>
                                <InputMask
                                    id="phone"
                                    value={phoneNumber}
                                    onChange={(e) => {
                                        setIsValid(true);
                                        setPhoneNumber(e.target.value);
                                    }}
                                    className={`w-full bg-slate-200 p-4 shadow-none ${
                                        !isValid
                                            ? "border-2 border-red-600"
                                            : ""
                                    }`}
                                    mask="(+999) 99-999-9999"
                                    placeholder="(+380) 99-999-9999"
                                />
                                {!isValid ? (
                                    <div className="text-center">
                                        <span className="text-red-600  text-xs">
                                            Введіть номер телефону в форматі{" "}
                                            <br></br>
                                            (+380) 99-999-9999
                                        </span>
                                    </div>
                                ) : null}
                            </div>

                            <div>
                                <label
                                    htmlFor="name"
                                    className="font-bold block mb-2"
                                >
                                    Імʼя
                                </label>
                                <InputText
                                    id="name"
                                    value={name}
                                    onChange={(e) => {
                                        setName(capitalize(e.target.value));
                                    }}
                                    className={`w-full bg-slate-200 p-4 shadow-none`}
                                    placeholder="Імʼя"
                                />
                            </div>
                        </div>
                    </div>

                    <Button
                        onClick={handleClick}
                        disabled={!isValid}
                        className="bg-slate-200 hover:bg-slate-300 p-4 mt-4 shadow-none text-nowrap"
                        label="Зв'яжіться зі мною"
                    />
                </>
            )}
        </div>
    );
}

export default ContactMeBlock;
